import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useUserDetialsContext } from '../context/user-details';
import PageContainer from '../components/UI/PageContainer';
import CharacterDeepDivePanel from '../components/lab-v4/CharacterDeepDivePanel';

export default function CharacterDeepDivePage() {
    const { deepDiveId } = useParams();
    const navigate = useNavigate();
    const { userDetails } = useUserDetialsContext();

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchStatus = useCallback(async () => {
        if (!deepDiveId || !userDetails?.tokenId) return false;
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}v4/character/deep-dive/status/${deepDiveId}/`,
                {
                    method: 'GET',
                    headers: { Authorization: `Bearer ${userDetails.tokenId}` },
                }
            );
            const json = await response.json();
            if (response.ok && json.success) {
                setData(json);
                if (json.status === 'COMPLETED' || json.status === 'FAILED') {
                    setLoading(false);
                    return true;
                }
            } else {
                setError(json.error || 'Failed to load deep dive');
                setLoading(false);
                return true;
            }
        } catch (e) {
            console.error('Deep dive fetch error:', e);
            setError(e.message);
        }
        return false;
    }, [deepDiveId, userDetails?.tokenId]);

    useEffect(() => {
        let intervalId;
        let active = true;
        const poll = async () => {
            const done = await fetchStatus();
            if (done && intervalId) clearInterval(intervalId);
        };
        if (deepDiveId && userDetails?.tokenId) {
            poll();
            intervalId = setInterval(() => {
                if (active) poll();
            }, 3000);
        }
        return () => {
            active = false;
            if (intervalId) clearInterval(intervalId);
        };
    }, [deepDiveId, userDetails?.tokenId, fetchStatus]);

    return (
        <PageContainer className="px-4 md:px-6 lg:pr-8 lg:!pl-[13rem]">
            <div className="max-w-6xl mx-auto py-6">
                <button
                    type="button"
                    onClick={() => navigate('/lab-v4')}
                    className="mb-4 text-sm text-gray-400 hover:text-white inline-flex items-center gap-1"
                >
                    ← Back to Lab V4
                </button>

                {error ? (
                    <div className="p-6 rounded-2xl bg-red-900/20 border border-red-800 text-red-300">
                        {error}
                    </div>
                ) : !data && loading ? (
                    <div className="p-12 text-center text-gray-400">Loading deep dive…</div>
                ) : (
                    <div className="rounded-2xl bg-gray-800 border border-gray-600 shadow-2xl overflow-hidden">
                        <CharacterDeepDivePanel data={data} onClose={() => navigate('/lab-v4')} />
                    </div>
                )}
            </div>
        </PageContainer>
    );
}
